<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<h1 class="title">Table of Contents</h1>
<p class="toc_entry_chapter"><span href="#/9781439635131_titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_copyright" title="Link target outside of Sample">Copyright Page</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_dedication" title="Link target outside of Sample">dedication</span></p>
<p class="toc_entry_chapter"><a href="#/9781439635131_acknowledgements">ACKNOWLEDGMENTS</a></p>
<p class="toc_entry_chapter"><a href="#/9781439635131_introduction">INTRODUCTION</a></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch1" title="Link target outside of Sample">One: PIONEER DAYS</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch2" title="Link target outside of Sample">Two: TILLING THE PRAIRIE</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch3" title="Link target outside of Sample">Three: MILLERS, MERCHANTS, AND MANUFACTURERS</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch4" title="Link target outside of Sample">Four: TRAILS, TRAINS AND TROLLEYS</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch5" title="Link target outside of Sample">Five: SCHOOL DAYS</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch6" title="Link target outside of Sample">Six: OSWEGO GOES TO WAR</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch7" title="Link target outside of Sample">Seven: SERVING THE PEOPLE</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch8" title="Link target outside of Sample">Eight: FAITH ON THE PRAIRIE</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_ch9" title="Link target outside of Sample">Nine: TIME OUT FOR FUN</span></p>
<p class="toc_entry_chapter"><span href="#/9781439635131_bibliography" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781439635131_toc.vue?6a45f566